'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Placement = require('./utils/Placement');

var _PlacementConstants = require('./PlacementConstants');

var _sizes = require('HubStyleTokens/sizes');

var _SafePureComponent2 = require('../core/SafePureComponent');

var _SafePureComponent3 = _interopRequireDefault(_SafePureComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mediumArrowSize = parseInt(_sizes.POPOVER_ARROW_SIZE, 10);
var smallArrowSize = parseInt(_sizes.TOOLTIP_ARROW_SIZE, 10);

var getStyles = function getStyles(color, inset, placement, width) {
  var styles = {
    backgroundColor: color,
    borderTopColor: 'transparent',
    borderLeftColor: 'transparent',
    width: width,
    height: width
  };

  switch ((0, _Placement.getSide)(placement)) {
    case 'top':
      // Arrow points down
      styles.transform = 'rotate(45deg)';
      styles.top = 'calc(100% - ' + width / 2 + 'px)';
      break;
    case 'right':
      // Arrow points left
      styles.transform = 'rotate(135deg)';
      styles.left = -(width / 2);
      break;
    case 'bottom':
      // Arrow points up
      styles.transform = 'rotate(-135deg)';
      styles.top = -(width / 2);
      break;
    case 'left':
      // Arrow points right
      styles.transform = 'rotate(-45deg)';
      styles.left = 'calc(100% - ' + width / 2 + 'px)';
      break;
    default:
      break;
  }

  // Magic calculation, haven't quite figured this out yet
  var adjustedInset = inset + 3;

  switch ((0, _Placement.getEdge)(placement)) {
    case 'top':
      // Arrow is near the bottom of the left or right side
      styles.bottom = adjustedInset;
      break;
    case 'middle':
      // Arrow is in the middle of the left or right side
      styles.top = 'calc(50% - ' + width / 2 + 'px)';
      break;
    case 'bottom':
      // Arrow is near the top of the left or right side
      styles.top = adjustedInset;
      break;
    case 'left':
      // Arrow is near the right of the top or bottom side
      styles.right = adjustedInset;
      break;
    case 'center':
      // Arrow is in the center of the top or bottom side
      styles.left = 'calc(50% - ' + width / 2 + 'px)';
      break;
    case 'right':
      // Arrow is near the left of the top or bottom side
      styles.left = adjustedInset;
      break;
    default:
      break;
  }

  return styles;
};

var UIPopoverArrow = function (_SafePureComponent) {
  _inherits(UIPopoverArrow, _SafePureComponent);

  function UIPopoverArrow() {
    _classCallCheck(this, UIPopoverArrow);

    return _possibleConstructorReturn(this, (UIPopoverArrow.__proto__ || Object.getPrototypeOf(UIPopoverArrow)).apply(this, arguments));
  }

  _createClass(UIPopoverArrow, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          color = _props.color,
          inset = _props.inset,
          placement = _props.placement,
          width = _props.width;

      if (width === 0) {
        return null;
      }

      return _react2.default.createElement('div', {
        className: 'uiPopoverArrow private-popover__arrow',
        style: getStyles(color, inset, placement, width)
      });
    }
  }]);

  return UIPopoverArrow;
}(_SafePureComponent3.default);

UIPopoverArrow.propTypes = {
  color: _react.PropTypes.string,
  inset: _react.PropTypes.number.isRequired,
  placement: _react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS).isRequired,
  width: _react.PropTypes.number
};

UIPopoverArrow.defaultProps = {
  inset: 0,
  placement: 'top',
  width: 20
};

UIPopoverArrow.ARROW_SIZES = {
  none: {
    distance: 4,
    inset: 0,
    width: 0
  },
  medium: {
    distance: mediumArrowSize,
    inset: mediumArrowSize - 2,
    width: 20
  },
  small: {
    distance: smallArrowSize,
    inset: smallArrowSize - 2,
    width: 16
  }
};

exports.default = UIPopoverArrow;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1755/js/tooltip/UIPopoverArrow.js
// module id = 472
// module chunks = 2 3